import { ComponentsManager, Component, EventBus } from '../core/smpl-components.js'

import { ThumbSlider } from '../modules/thumb-slider.js'

//
export default class extends Component {
	prepare() {
		this.elSliderContainer = this.element.querySelector('.landscape-slider__inner')
		// this.slider = EmblaCarousel(this.elSliderContainer, {
		// 	// watchDrag: false,
		// 	loop: true,
		// 	skipSnaps: true,
		// 	align: 'start',
		// })
		// console.log(this.slider)

		this.slider = new ThumbSlider({
			element: this.element,
			container: this.elSliderContainer,
			enableControls: true,
		})

		// this.slider = new ThumbSlider({
		// 	element: this.elSliderContainer,
		// 	elCurrentIndex: this.elCurrentIndex,
		// })
	}

	mount() {}

	unmount() {}
}
